// DAS-2766: the three-line scoreboard — your real DeGiro value vs the untouched
// 1-January portfolio vs the same start capital in a simple index mix. Makes the
// cost/benefit of trading visible every day (the DAS-2759 lesson as a panel).
// Self-contained: fetches its own data, renders nothing while no data exists.
import React, { useState, useEffect } from 'react';
import api from '../functions/api';

const eur = (v) => v == null ? '—' : '€' + Math.round(v).toLocaleString('nl-NL');
const gap = (v) => {
  if (v == null) return null;
  const sign = v >= 0 ? '+' : '−';
  return `${sign}€${Math.round(Math.abs(v)).toLocaleString('nl-NL')}`;
};

const ScoreboardPanel = () => {
  const [row, setRow] = useState(null);

  useEffect(() => {
    api.get('/scoreboard')
      .then(res => setRow(res.data?.current || null))
      .catch(() => setRow(null));
  }, []);

  if (!row || row.frozen_eur == null) return null;

  const tradesGap = row.actual_eur != null ? row.actual_eur - row.frozen_eur : null;
  const indexGap = row.actual_eur != null ? row.actual_eur - row.index_eur : null;
  const colorFor = (v) => (v == null ? '#888' : v >= 0 ? '#389e0d' : '#cf1322');

  const line = { display: 'flex', justifyContent: 'space-between', gap: 16, padding: '2px 0' };
  return (
    <div
      data-testid="scoreboard-panel"
      style={{
        border: '1px solid #d9d9d9', borderRadius: 8, padding: '8px 14px',
        marginBottom: 12, fontSize: 13, maxWidth: 480, background: '#fafafa',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>
        Scoreboard — DeGiro, since 1 January <span style={{ fontWeight: 400, color: '#888' }}>({row.date})</span>
      </div>
      <div style={line}>
        <span>Your DeGiro</span>
        <b>{eur(row.actual_eur)}</b>
      </div>
      <div style={line} title="What the portfolio would be worth if you had not touched it since 1 January (incl. dividends you would have received)">
        <span>If untouched since 1 Jan: {eur(row.frozen_eur)}</span>
        <b style={{ color: colorFor(tradesGap) }}>
          your trades: {gap(tradesGap) ?? '—'}
        </b>
      </div>
      <div style={line} title="The same 1-January start capital in a simple mix: 90% world shares (VWRL), 10% EUR government bonds, rebalanced quarterly">
        <span>Same money in an index mix: {eur(row.index_eur)}</span>
        <b style={{ color: colorFor(indexGap) }}>
          you vs the index: {gap(indexGap) ?? '—'}
        </b>
      </div>
    </div>
  );
};

export default ScoreboardPanel;
